<template>
  <div class="ws-modal">
    <form class="ws-modal__form" @submit.prevent="submit">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">
          <span v-if="!isNewItem" v-text="$t('Редактировать обследование')"></span>
          <span v-else v-text="$t('Запрос на обследование')"></span>
        </h2>
      </header>
      <div class="ws-modal__content">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field class="ws-field"
                     :label="$t('Профессия/специальность (ДЭ)')"
                     :type="{'is-danger': errors.has('competence')}"
                     :message="errors.first('competence')">
              <ws-refbook-field
                entity="competence"
                name="competence"
                field="name.display"
                :isFocus="true"
                :data-vv-as="$t('Профессия/специальность (ДЭ)')"
                v-model="newItem.competency.name.translate.ru"
                :guid.sync="newItem.competency.guid"
                :disabled="!isUserCanEdit"
                v-validate="{ required: true, selected: newItem.competency.guid }" />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field class="ws-field"
                     :label="$t('Сложность (КОД)')"
                     :type="{'is-danger': errors.has('complexity_level')}"
                     :message="errors.first('complexity_level')">
              <WsSelectComplexityCode
                  class="ws-field__control"
                  name="complexity_level"
                  v-validate="{ required: true }"
                  :value="newItem.complexity_level"
                  :data-vv-as="$t('Сложность (КОД)')"
                  :placeholder="$t('')"
                  open-on-focus
                  :onChange="onChangeComplexy"
              />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field class="ws-field is-required"
                     :label="$t('Количество рабочих мест')"
                     :type="{'is-danger': errors.has('workers')}"
                     :message="errors.first('workers')">
              <b-input class="ws-field__control"
                       v-model.number="newItem.workers"
                       v-validate="{ required: true }"
                       :disabled="!isUserCanEdit"
                       name="workers"
              />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field class="ws-field"
                     :label="$t('Наличие аккредитации')"
                     :type="{'is-danger': errors.has('prev_accreditation')}"
                     :message="errors.first('prev_accreditation')">
              <b-select class="ws-field__control"
                        name="prev_accreditation"
                        v-model="newItem.prev_accreditation"
                        :placeholder="$t('')"
                        :disabled="isDisabledPrevAccreditation"
                        expanded>
                <option :value="true" v-text="$t('Да')"></option>
                <option :value="false" v-text="$t('Нет')"></option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12">
            <b-field class="ws-field is-required"
                     :label="$t('Комментарий по работе с файлами')"
                     :type="{'is-danger': errors.has('comment')}"
                     :message="errors.first('workers')">
              <b-input class="ws-field__control"
                       v-model="newItem.comment"
                       name="comment"
              />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field class="ws-field is-required"
              :label="$t('Статус')"
            >
              <b-input class="ws-field__control"
                :value="item.suspended ?
                  'Аттестат приостановлен' : isAcredentialled ?
                    'Обследован до ' + expires_at_formatted : 'Не обследован'"
                name="status"
                disabled
              />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field class="ws-field is-required"
              :label="$t('номер обследования')"
            >
              <b-input class="ws-field__control"
                v-model.number="newItem.number"
                type="number"
                name="number"
                :disabled="!isUserCanEdit"
              />
            </b-field>
          </div>
          <div class="column is-6">
            <b-field>
                <b-checkbox
                  v-model="newItem.prolonged"
                  type="is-info"
                  style="padding: 12px 0;"
                  :disabled="!isUserCanEdit"
                >
                  <span>Пролонгирован</span>
                </b-checkbox>
              </b-field>
          </div>
          <ws-role-node :only="['front_assessor', 'front_admin']">
            <div class="column is-12">
              <div class="field">
                <b-switch v-model="isAcredentialled">{{ $t('Обследован') }}</b-switch>
              </div>
              <div class="ws-datepicker" v-if="isAcredentialled">
                <b-field class="ws-field"
                  :label="$t('Обследован до')"
                  :type="{ 'is-danger': errors.has('expires_at') }"
                  :message="errors.first('expires_at')"
                >
                  <ws-datepicker
                          v-model="expires_at"
                          v-validate="'correctDate'"
                          name="ended_at"
                          class="ws-field__control">
                  </ws-datepicker>
                </b-field>
              </div>
            </div>
          </ws-role-node>
          <ws-accred-comps-documents :items="newItem.documents" :accred-comp-guid="newItem.guid" @change="updateItemDocuments" />
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button :disabled="isAuditor" class="ws-button button is-large is-primary is-fullwidth" :class="{'is-loading': isUpdatePending}">
                <span class="is-size-4 has-text-weight-bold" v-if="!isNewItem" v-text="$t('Редактировать')"></span>
                <span class="is-size-4 has-text-weight-bold" v-else v-text="$t('Создать')"></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click="close">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import computedDateProp from '@/utils/computedDateProp'
import { isDeCenterAccredited } from '@/utils/isDeCenterAccreditated'
import { constants } from '@/services/constants.service'
import moment from 'moment'
import WsSelectComplexityCode from '@/components/common/WsSelectComplexityCode.vue'
import { get } from 'lodash'

export default {
  name: 'WsRequestAccredCompsForm',
  components: { WsSelectComplexityCode },
  props: {
    guid: {
      type: String
    },
    item: {
      type: Object,
      default: () => {
        return {
          name: {
            translate: {
              ru: ''
            }
          },
          de_center: {
            guid: null,
            title: {
              translate: {
                ru: ''
              }
            }
          },
          competency: {
            guid: null,
            name: {
              translate: {
                ru: ''
              }
            },
            code: null,
            main_files: null,
            additional_files: null,
            task_files: null,
            complexity_level: null,
            tasks_options: null,
            individual: true,
            age_category: null,
            description: ''
          },
          day_cm1: null,
          started_at: null,
          ended_at: null,
          flags: {
            university_degree: false,
            secondary_degree: false,
            corporate: false,
            total: false,
            intermediate: false,
            voluntary_qualify_exam: false,
            commercial_exam: false
          },
          complexity_level: null,
          status: 'new'
        }
      }
    }
  },
  data () {
    return {
      isAcredentialled: false,
      newItem: {},
      constants
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (item) {
        this.newItem = Object.assign({}, item || this.item)
        this.isAcredentialled = isDeCenterAccredited(this.newItem, this.item.flags)
      }
    },
    newItem: {
      deep: true,
      handler (item) {
        // console.log(item.documents)
      }
    },
    isAcredentialled: {
      handler (item) {
        if (!item) {
          this.newItem.expires_at = null
          this.newItem.workers = 0
        } else {
          const date = new Date()
          date.setFullYear(date.getFullYear() + 1)
          this.newItem.expires_at = date
          this.newItem.workers = 1
        }
      }
    }
  },
  computed: {
    ...mapState('authentication', ['user']),
    permRefbookFiles () {
      return get(this.user, 'permission.scope.services.refbook.files', [])
    },
    ...mapState('de-centers', {
      isUpdatePending: 'isUpdatePending'
    }),
    ...mapState('authentication', ['currentRole']),
    isAuditor () {
      return this.currentRole === 'front_auditor'
    },
    isUserCanEdit () {
      return this.currentRole === 'front_assessor' || this.currentRole === 'front_admin'
    },
    expires_at: computedDateProp('newItem', 'expires_at'),
    expires_at_formatted () {
      if (!this.expires_at) return null
      return moment(this.expires_at).format('DD.MM.YYYY')
    },
    isNewItem () {
      return !(this.newItem && this.newItem.guid)
    },
    isDisabledPrevAccreditation () {
      return this.currentRole === 'front_rcc' || this.currentRole === 'front_curator'
    }
  },
  mounted () {
    this.$validator.pause()
  },
  methods: {
    ...mapActions('de-centers', ['update']),
    updateItemDocuments (items) {
      this.newItem.documents = items
    },
    onChangeComplexy (value) {
      this.newItem = {
        ...this.newItem,
        complexity_level: value
      }
    },
    async submit () {
      await this.$store.dispatch('authentication/populateUser')
      const isDelete = this.permRefbookFiles.includes('delete')
      this.$validator.resume()
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          try {
            if (this.newItem.documents) {
              const deleted = [...this.newItem.documents.filter(item => item.operation === 'delete').map(item => item.guid)]
              const update = [...this.newItem.documents.filter(item => item.operation && item.operation === 'update')]

              const res = await this.update([ this.guid, {
                'delete': isDelete ? [...deleted] : [],
                'update': [...update]
              }, `/accred_comps/${this.newItem.guid}/documents` ])

              if (update.length) {
                const cItem = res.accred_comps.find(i => i.guid === this.newItem.guid)
                if (cItem) {
                  for (let { file, status } of update) {
                    const doc = cItem.documents.find(i => i.file.guid === file.guid)
                    await this.update([ this.guid, [], `/accred_comps/${this.newItem.guid}/documents/${doc.guid}/status/${status}` ]).catch(e => console.log(e))
                  }
                }
              }
            }
            const deCenter = await this.update([ this.guid, { update: [ this.newItem ] }, '/accred_comps' ])
            this.$emit('added', deCenter)
            if (this.newItem.competency && this.newItem.competency.name && this.newItem.competency.name.translate) {
              this.$buefy.toast.open({
                message: this.$t(`Обследование ${this.newItem.competency.name.translate.ru} была успешно обновлена`),
                type: 'is-success'
              })
            }
          } catch (e) {
            this.$buefy.toast.open({
              message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
              type: 'is-danger'
            })
          }
          this.close()
        }
      })
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
